import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { DollarInputField } from '../../Fields';

interface BusinessGrossProps extends IncomeEntityIndex {
  hasLabel?: boolean;
  isOptional?: boolean;
  isDisabled?: boolean;
}

export const BusinessGross = (props: BusinessGrossProps) => {
  const { hasLabel = false, incomeIndex, ...rest } = props;

  return (
    <DollarInputField
      {...rest}
      isZeroValid
      name={FIELD_PATHS.INCOME_BUSINESS_GROSS(incomeIndex)}
      label={hasLabel ? 'Self-declaration gross in the last financial year' : undefined}
    />
  );
};
